import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { sendEvent } from '../../shared/search-event';
import theme from '../../../assets/stylesheets/_settings.global.scss';
import LogoSeparator from '../shared/logo-separator';
import Company from './listed-company-results-components/company';
import WiresMentioning from './listed-company-results-components/wires-mentioning';
import TopKeywords from './listed-company-results-components/top-keywords';
import TopContributors from './listed-company-results-components/top-contributors';
import StockCodeHeader from '../stock-codes/stock-code-header';
import ListedCompanyCodeResultsContext, { reducer, defaultState } from './listed-company-results-components/context';

const Columnar = styled.div`
  padding-top: ${props => (props.theme.isDesktop ? 49 : 25)}px;

  & section.sidebar > article:first-child {
    margin-top: 0;
  }
`;

export default function SearchResultsListedCompany(props) {
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  const isDesktop = useMediaQuery({ query: `(min-width: ${theme.breakpointLargeMax})` });
  const [st, dispatch] = React.useReducer(reducer, defaultState);
  const { stockCode, isProductPage, ad } = props;

  React.useEffect(() => {
    (async () => sendEvent())();
  }, []);

  const className = isDesktop || isMobile ? 'columnar' : 'columnar no-sidebar';

  return (
    <ThemeProvider theme={{ ...props, ...theme, isDesktop }}>
      <ListedCompanyCodeResultsContext.Provider value={{ state: st, dispatch }}>
        <React.Fragment>
          {
            isProductPage && <StockCodeHeader stockCode={stockCode} secondaryHeadline />
          }
          <Columnar className={className}>
            <section className="content">
              {!isProductPage && <Company stockCode={stockCode} />}
              {!isProductPage && isDesktop && <LogoSeparator />}
              {!isDesktop && (
                <React.Fragment>
                  <TopContributors stockCode={stockCode} />
                  <TopKeywords stockCode={stockCode} />
                </React.Fragment>
              )}
              <WiresMentioning stockCode={stockCode} />
              {!!(st.wiresMentioning.length) && (
                <LogoSeparator animate={st.loadingWiresMentioning === 'more'} />
              )}
            </section>
            {isDesktop && (
              <section className="sidebar">
                <TopContributors stockCode={stockCode} />
                <div className="mt-6 hidden lg:block" dangerouslySetInnerHTML={{ __html: ad }} />
                <TopKeywords stockCode={stockCode} />
              </section>
            )}
          </Columnar>
        </React.Fragment>
      </ListedCompanyCodeResultsContext.Provider>
    </ThemeProvider>
  );
}

SearchResultsListedCompany.propTypes = {
  stockCode: PropTypes.shape({
    stockExchange: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    isStockCodeFollowedByCurrentUser: PropTypes.bool.isRequired,
    mentionedIn30DaysCount: PropTypes.number.isRequired,
    totalMentionedCount: PropTypes.number.isRequired,
  }).isRequired,
  isProductPage: PropTypes.bool,
  ad: PropTypes.string.isRequired,
};

SearchResultsListedCompany.defaultProps = {
  isProductPage: false,
};
